import { XMLParser, XMLValidator } from 'fast-xml-parser'
export class OFXParserService {
    parser = new XMLParser()
    _sgml2Xml(sgml) {
        return sgml
            .replace(/>\s+</g, '><') // remove whitespace inbetween tag close/open
            .replace(/\s+</g, '<') // remove whitespace before a close tag
            .replace(/>\s+/g, '>') // remove whitespace after a close tag
            .replace(/<([A-Z0-9_]*)+\.+([A-Z0-9_]*)>([^<]+)/g, '<$1$2>$3')
            .replace(/<(\w+?)>([^<]+)/g, '<$1>$2</$1>')
    }

    // Preparing data fixing issues with special characters
    _prepareData(content: string) {
        return content.replace(/\s+/g, ' ').trim().replace(/&/g, '&amp;amp;')
    }

    _parseXml(content) {
        const options = {
            ignoreAttributes: true,
            parseAttributeValue: true,
            ignoreNameSpace: false,
            allowBooleanAttributes: false,
            parseNodeValue: false,
            // numberParseOptions: {
            //     leadingZeros: true,
            //     skipLike: /./,
            // },
            trimValues: true,
            parseTrueNumberOnly: true,
        }
        const validation = XMLValidator.validate(content, {})
        if (validation === true) {
            return this.parser.parse(content, options)
        }
        console.log('ofx-parser_file-validation-error', validation)
        throw new Error('Error while parsing content')
    }

    _fixBadOFX(ofx: string) {
        // stone
        if (ofx.includes('<FID>197</FID>') && !ofx.includes('</DTSERVER>')) {
            ofx = ofx.replace('[0:GMT]', '[0:GMT]</DTSERVER>')
        }
        // banco do brasil /
        if (ofx.includes('<FID>001')) {
            ofx = this._ofxSgmlToXml(ofx)
        }

        return ofx
    }

    // converte OFX com tags abertas para fechadas.
    // até o momento detectei no BB apenas.
    _ofxSgmlToXml(ofx: string) {
        return ofx
            .replace(/\r\n/g, '\n')
            .split('\n')
            .map((line) => {
                const trimmed = line.trim()

                // ignora header e fechamentos
                if (!trimmed.startsWith('<') || trimmed.startsWith('</')) {
                    return line
                }

                // ignora containers (<TAG>)
                if (/^<[A-Z0-9_.]+>$/.test(trimmed)) {
                    return line
                }

                // leaf tag sem fechamento: <TAG>valor
                const match = trimmed.match(/^<([A-Z0-9_.]+)>([^<]*)$/)
                if (match) {
                    const [, tag, value] = match
                    return line.replace(trimmed, `<${tag}>${value.trim()}</${tag}>`)
                }

                return line
            })
            .join('\n')
    }

    toJSON(data) {
        // fix bad OFX
        data = this._fixBadOFX(data)

        // firstly, split into the header attributes and the footer sgml
        const ofx = data.split('<OFX>', 2)

        // firstly, parse the headers
        const headerString = ofx[0].split(/\r?\n/)
        const header = {}
        headerString.forEach((attrs) => {
            const headAttr = attrs.split(/:/, 2)
            header[headAttr[0]] = headAttr[1]
        })

        // make the SGML and the XML
        const content = `<OFX>${ofx[1]}`

        // Parse the XML/SGML portion of the file into an object
        // Try as XML first, and if that fails do the SGML->XML mangling
        let dataParsed = null
        try {
            dataParsed = this._parseXml(this._prepareData(content))
        } catch (e) {
            dataParsed = this._parseXml(this._prepareData(this._sgml2Xml(content)))
        }

        // put the headers into the returned data
        dataParsed.header = header
        //
        dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKACCTFROM.ACCTID = dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKACCTFROM.ACCTID.toString()
            .replace('-', '')
            .toString()
        let token =
            (dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKACCTFROM.BANKID || '') +
            '-' +
            (dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKACCTFROM.BRANCHID || '') +
            '-' +
            dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKACCTFROM.ACCTID
        let lastDate = ''
        let pos = 0
        if (!Array.isArray(dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKTRANLIST.STMTTRN)) {
            dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKTRANLIST.STMTTRN = [dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKTRANLIST.STMTTRN]
        }
        for (let entry of dataParsed.OFX.BANKMSGSRSV1.STMTTRNRS.STMTRS.BANKTRANLIST.STMTTRN) {
            if (lastDate !== entry.DTPOSTED.toString().substring(0, 8)) {
                lastDate = entry.DTPOSTED.toString().substring(0, 8)
                pos = 0
            }
            pos += 1
            entry._id = token + '-' + lastDate + '-' + pos
            entry._id = entry._id
                .split('')
                .map((c) => c.charCodeAt(0).toString(16).padStart(2, '0'))
                .join('')
            entry.DTPOSTED = this._parseDateString(entry.DTPOSTED)
            entry.TRNAMT = parseFloat(entry.TRNAMT.toString().replace(',', '.'))
        }

        return dataParsed
    }

    _parseDateString(dateString) {
        dateString = dateString.toString()
        console.log('ds', dateString)
        const year = dateString.substr(0, 4)
        const month = dateString.substr(4, 2)
        const day = dateString.substr(6, 2)
        let hour = 0
        let minute = 0
        let second = 0
        let tz: string = '-0600'
        try {
            tz = JSON.stringify(new Date().toString()).split('GMT')[1].split(' ')[0]
        } catch (error) {}
        if (!tz.includes('-')) tz = '+' + tz
        if (dateString.length > 8) {
            hour = dateString.substr(8, 2)
            minute = dateString.substr(10, 2)
            second = dateString.substr(12, 2)
            if (dateString.includes('[')) {
                tz = dateString.split('[')[1].split(':')[0]
                if (!tz.includes('-') && !tz.includes('+')) {
                    tz = '+' + tz
                }
            }
            if (tz.length === 2) tz = tz.substring(0, 1) + '0' + tz.substring(1, 2)
            if (tz.length === 3) tz = tz + '00'
        }

        const isoDateString = `${year}-${month}-${day} ${hour}:${minute}:${second}.${0}${0}${0}${tz}`
        const date = new Date(isoDateString)
        return date
    }

    toOFX(header, body) {
        let out = ''
        // header order could matter
        const headers = ['OFXHEADER', 'DATA', 'VERSION', 'SECURITY', 'ENCODING', 'CHARSET', 'COMPRESSION', 'OLDFILEUID', 'NEWFILEUID']

        headers.forEach((name) => {
            out += `${name}:${header[name]}\n`
        })
        out += '\n'

        out += this._objToOfx({ OFX: body })
        return out
    }

    _objToOfx(obj) {
        let out = ''

        Object.keys(obj).forEach((name) => {
            const item = obj[name]
            const start = `<${name}>`
            const end = `</${name}>`

            if (item instanceof Object) {
                if (item instanceof Array) {
                    item.forEach((it) => {
                        out += `${start}\n${this._objToOfx(it)}${end}\n`
                    })
                    return
                }
                return (out += `${start}\n${this._objToOfx(item)}${end}\n`)
            }
            out += start + item + '\n'
        })

        return out
    }
}
